import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiRadioGroup } from '@material-ui/core/RadioGroup';
import { Typography } from '../Typography';
import { HideOffScreen } from '../HideOffScreen';
import { FormControl } from '../FormControl';
import { FormLabel } from '../FormLabel';
export var RadioGroup = React.forwardRef(function (props, ref) {
    var children = props.children, hasCustomLegend = props.hasCustomLegend, isRequired = props.isRequired, legendText = props.legendText, legendVariant = props.legendVariant, requiredLabel = props.requiredLabel, other = __rest(props, ["children", "hasCustomLegend", "isRequired", "legendText", "legendVariant", "requiredLabel"]);
    var Fieldset = FormControl;
    var Legend = FormLabel;
    var setFieldsetLegend = function () { return (React.createElement(Fieldset, { component: "fieldset" },
        React.createElement(Legend, { component: "legend", required: isRequired },
            React.createElement(Typography, { variant: legendVariant, component: "span" },
                legendText,
                requiredLabel && React.createElement(HideOffScreen, null, requiredLabel),
                ' ')),
        React.createElement(MuiRadioGroup, __assign({ ref: ref, "aria-required": undefined, role: undefined, "aria-label": undefined }, other), children))); };
    var noFieldsetLegend = function () { return (React.createElement(MuiRadioGroup, __assign({ ref: ref, "aria-required": undefined, role: undefined, "aria-label": undefined }, other), children)); };
    if (!hasCustomLegend && !legendText) {
        throw new Error('legendText must be provided when setting hasCustomLegend=false');
    }
    if (isRequired && !requiredLabel) {
        throw new Error('requiredLabel must be provided when setting isRequired="true"');
    }
    if (!hasCustomLegend) {
        return setFieldsetLegend();
    }
    return noFieldsetLegend();
});
RadioGroup.defaultProps = {
    hasCustomLegend: false,
    isRequired: false,
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map